import { useCallback, useEffect, useState } from "react";
import { PLYMOUTH_STOPS } from "../utils/bods";

function getStopsApiUrl() {
  return process.env.REACT_APP_STOPS_API_URL || "/api/stops";
}

export function usePlymouthStops() {
  const [stops, setStops] = useState(PLYMOUTH_STOPS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [source, setSource] = useState("Local fallback");

  const loadStops = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(getStopsApiUrl(), {
        headers: { Accept: "application/json" },
      });

      const contentType = response.headers.get("content-type") || "";
      const raw = await response.text();

      if (!contentType.includes("application/json")) {
        throw new Error(
          "The /api/stops route is not running. For local testing use `npx vercel dev` instead of plain `npm start`, or deploy to Vercel."
        );
      }

      const data = JSON.parse(raw);

      if (!response.ok) {
        throw new Error(data.detail || data.error || `Stop download failed: ${response.status}`);
      }

      if (!Array.isArray(data.stops) || data.stops.length === 0) {
        throw new Error("No Plymouth stops returned by NaPTAN");
      }

      setStops(data.stops);
      setSource(data.source || "DfT NaPTAN");
    } catch (err) {
      setStops(PLYMOUTH_STOPS);
      setSource("Local fallback");
      setError(err.message || "Could not load Plymouth stop list");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadStops();
  }, [loadStops]);

  return { stops, loading, error, source, reload: loadStops };
}
